// src/components/Layout.jsx
import { Outlet, Link } from 'react-router-dom';
import Navbar from './Navbar.jsx';

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="border-t mt-8 py-6 text-center text-xs text-gray-400 space-x-3">
        <span>© {new Date().getFullYear()} CitizenCast</span>
        <Link to="/privacy" className="hover:text-gray-600 underline">Privacy</Link>
        <Link to="/terms" className="hover:text-gray-600 underline">Terms</Link>
      </footer>
    </div>
  );
}
